__turbopack_context__.v({
  "narrow": "tK2c6G_narrow",
  "section": "tK2c6G_section",
  "smallHeading": "tK2c6G_smallHeading",
  "textLink": "tK2c6G_textLink",
});
